"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientData = void 0;
const GetCookie_1 = require("./GetCookie");
/**
 * 获取保存在浏览器的登录信息
 * @param name key值
 */
function getClientData(name) {
    if (window.localStorage) {
        const value = window.localStorage.getItem(name);
        return value ?? '';
    }
    else if (document.cookie) {
        return (0, GetCookie_1.getCookie)(name) || '';
    }
    else {
        return '';
    }
}
exports.getClientData = getClientData;
//# sourceMappingURL=GetClientData.js.map